// Import: Middleware Action & Custom Types
import {
    CLEAN_DETAIL_TRANSFER_SALES,
    CLEAN_DETAIL_TRANSFER_SALES_ERROR,
} from "_models/redux/types";

// Action function
export const cleanDetailTransferSalesClean = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            type: CLEAN_DETAIL_TRANSFER_SALES,
            payload: undefined,
        });
    } catch (e) {
        dispatch({
            type: CLEAN_DETAIL_TRANSFER_SALES_ERROR,
            payload: undefined,
        });
    }
};
